import { o as r, F as t, H as a, G as p } from "./resize-bus--fbPUAE-.mjs";
import { defineAsyncComponent as o } from "vue";
import { $gmapOptions as l } from "./keys.es.js";
globalThis.GoogleMapsApi = { isReady: !1 };
function s() {
  return globalThis.GoogleMapsApi.isReady && globalThis.google;
}
const y = {
  googleMapsApiInitializer: r,
  pluginComponentBuilder: t,
  getGoogleMapsAPI: s
}, d = (e) => (m) => {
  const i = {
    dynamicLoad: !1,
    ...e,
    load: {
      libraries: "places",
      ...e == null ? void 0 : e.load
    }
  }, n = p(
    r,
    globalThis.GoogleMapsApi
  )(i);
  a(i, n), m.config.globalProperties.$gmapApiPromiseLazy = n, m.config.globalProperties.$gmapOptions = i, m.provide(l, i), m.component(
    "GmvMap",
    o(() => import("./map-layer-CRvid19D.mjs"))
  ).component(
    "GmvMarker",
    o(() => import("./marker-icon-BlvJTN-M.mjs"))
  ).component(
    "GmvInfoWindow",
    o(() => import("./info-window-CdjYBi-X.mjs"))
  ).component(
    "GmvKmlLayer",
    o(() => import("./kml-layer-Cw3Cl1Ud.mjs"))
  ).component(
    "GmvAutocomplete",
    o(
      () => import("./autocomplete-input-ssE2hgis.mjs")
    )
  ).component(
    "GmvStreetViewPanorama",
    o(
      () => import("./street-view-panorama-BWouMZJg.mjs")
    )
  ).component(
    "GmvHeatmapLayer",
    o(() => import("./heatmap-layer-Dx9A2oE1.mjs"))
  ).component(
    "GmvCircle",
    o(() => import("./circle-shape-CAj_XB04.mjs"))
  ).component(
    "GmvPolygon",
    o(() => import("./polygon-shape-LtyhlcLx.mjs"))
  ).component(
    "GmvPolyline",
    o(() => import("./polyline-shape-CcR5pka7.mjs"))
  ).component(
    "GmvRectangle",
    o(() => import("./rectangle-shape-PqNs3_y6.mjs"))
  ).component(
    "GmvDrawingManager",
    o(() => import("./drawing-manager-CV_qn5ZB.mjs"))
  ).component(
    "GmvCluster",
    o(() => import("./cluster-icon-f_Qk7X4h.mjs"))
  );
};
export {
  d as createGmapVuePlugin,
  y as utilities
};
